import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

/* ──────── imagens ──────── */
//import receipt from "../assets/img/report-black.svg";
import courtesy from "../assets/img/courtesy-selected.png";
import creditCard from "../assets/img/credit-card-selected.png";
import cash from "../assets/img/money-selected.png";
import pix from "../assets/img/pix-selected.png";
//import bank from "../assets/img/credit-card-selected.png";

import formatDate from '../utils/formatDate'

/* ──────── estilos ──────── */
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 9,
    fontFamily: "Helvetica",
    flexDirection: "column",
  },
  title: { fontSize: 14, marginBottom: 10, fontWeight: "bold" },
  section: { marginBottom: 10 },
  tableHeader: {
    flexDirection: "row",
    borderBottom: 1,
    marginBottom: 4,
    paddingBottom: 4,
    fontWeight: "bold",
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: 1,
    paddingVertical: 2,
  },
  cell: { textAlign: "center", paddingHorizontal: 2 },
  w14: { width: "14%" },
  w16: { width: "16%" },
  w22: { width: "22%" },
  w10: { width: "10%" },
  w12: { width: "12%" },
  w14m: { width: "14%" }, // método com ícones
  totalSection: { marginTop: 10, textAlign: "right", fontSize: 9 },
  totalLine: { marginVertical: 5 },
  logo: { width: 80, height: 80, marginRight: 10 },
});

/* ──────── ícones por método ──────── */
const paymentMethodIcons = {
  credit: { icon: creditCard, label: "Crédito" },
  debit: { icon: cash, label: "Débito" },
  cash: { icon: cash, label: "Dinheiro" },
  pix: { icon: pix, label: "Pix" },
  courtesy: { icon: courtesy, label: "Cortesia" },
};

/* ──────── formatador de moeda ──────── */
const formatCurrency = (val) =>
  (parseFloat(val) || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

/* ──────── componente principal ──────── */
const ReportPDF = ({ payment, data, title }) => {
  const totals = data.reduce(
    (acc, cashier) => {
      const cardFee = cashier.payments.reduce(
        (f, p) => f + Number(p.fee_value || 0),
        0
      );
      acc.cardFees += cardFee;

      cashier.payments.forEach((p) => {
        acc.byMethod[p.method] =
          (acc.byMethod[p.method] || 0) + Number(p.amount || 0);
      });

      cashier.items.forEach((item) => {
        acc.records += 1;
        acc.cost += Number(item.cost_price || 0);
        acc.sell += Number(item.selling_price || 0);

        const sellWithDisc =
          item.net_individual ??
          (cashier.discount?.type === "percentage"
            ? Number(item.selling_price) *
            (1 - Number(cashier.discount.value || 0) / 100)
            : Number(item.selling_price) -
            Number(cashier.discount.amount || 0));

        acc.sellDisc += sellWithDisc;
      });

      return acc;
    },
    { records: 0, cost: 0, sell: 0, sellDisc: 0, cardFees: 0, byMethod: {} }
  );

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        {/* Cabeçalho */}
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <Image
            src={require("../assets/img/achemed-simbolo-azul.png")}
            style={styles.logo}
          />
          <View style={styles.section}>
            <Text style={styles.title}>
              {title}
            </Text>
            <Text>
              Gerado em : {new Date().toLocaleDateString("pt-BR")} às {new Date().toLocaleTimeString("pt-BR")}
            </Text>
            <Text>
              Período: {formatDate(payment?.start_date)} a {formatDate(payment?.end_date)}
            </Text>
            <Text>Mês de Repasse: {formatDate(payment?.transfer_month)}</Text>
          </View>
        </View>

        {/* Cabeçalho da tabela */}
        <View style={styles.tableHeader} fixed>
          <Text style={[styles.cell, styles.w16]}>Empresa Realizante</Text>
          <Text style={[styles.cell, styles.w14]}>Paciente</Text>
          <Text style={[styles.cell, styles.w22]}>Procedimento</Text>
          <Text style={[styles.cell, styles.w10]}>Repasse</Text>
          <Text style={[styles.cell, styles.w10]}>Venda</Text>
          <Text style={[styles.cell, styles.w10]}>Venda c/ desc.</Text>
          <Text style={[styles.cell, styles.w10]}>Taxas cartão</Text>
          <Text style={[styles.cell, styles.w14m]}>Método</Text>
        </View>

        {/* Linhas da tabela */}
        {data.map((cashier, cIdx) => {
          const cardFee = cashier.payments.reduce(
            (f, p) => f + Number(p.fee_value || 0),
            0
          );

          return cashier.items.map((item, iIdx) => {
            const sellWithDisc =
              item.net_individual ??
              (cashier.discount?.type === "percentage"
                ? Number(item.selling_price) * (1 - Number(cashier.discount.value || 0) / 100)
                : Number(item.selling_price) - Number(cashier.discount.amount || 0));

            const uniqueMethods = Array.from(
              new Set(cashier.payments.map((p) => p.method))
            );

            return (
              <View
                key={`${cIdx}-${iIdx}`}
                style={styles.tableRow}
                wrap={false}>
                <Text style={[styles.cell, styles.w16]}>
                  {item.executing_company}
                </Text>
                <Text style={[styles.cell, styles.w14]}>
                  {cashier.patient?.name}
                </Text>
                <Text style={[styles.cell, styles.w22]}>
                  {item.procedure_name}
                </Text>
                <Text style={[styles.cell, styles.w10]}>
                  {formatCurrency(item.cost_price)}
                </Text>
                <Text style={[styles.cell, styles.w10]}>
                  {formatCurrency(item.selling_price)}
                </Text>
                <Text style={[styles.cell, styles.w10]}>
                  {formatCurrency(sellWithDisc)}
                </Text>
                <Text style={[styles.cell, styles.w10]}>
                  {formatCurrency(cardFee)}
                </Text>

                {/* Coluna Método com ícones */}
                <View
                  style={[
                    styles.cell,
                    styles.w14m,
                    {
                      flexDirection: "row",
                      flexWrap: "wrap",
                      justifyContent: "center",
                    },
                  ]}>
                  {uniqueMethods.map((method, mIdx) => {
                    const data = paymentMethodIcons[method];
                    return data ? (
                      <View
                        key={mIdx}
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          margin: 1,
                        }}>
                        <Image
                          src={data.icon}
                          style={{ width: 10, height: 10, marginRight: 2 }}
                        />
                        <Text>{data.label}</Text>
                      </View>
                    ) : null;
                  })}
                </View>
              </View>
            );
          });
        })}

        {/* Totais */}
        <View style={styles.totalSection}>
          <Text style={styles.totalLine}>Registros: {totals.records}</Text>
          <Text style={[styles.totalLine, { fontSize: 12 }]}>Total Repasse: {formatCurrency(totals.cost)}</Text>
          <Text style={[styles.totalLine, { fontSize: 12 }]}>Total Venda: {formatCurrency(totals.sell)}</Text>

          <Text style={[styles.totalLine, { fontSize: 12 }]}>Total Taxas Cartões: {formatCurrency(totals.cardFees)}</Text>

          {/* {Object.entries(totals.byMethod).map(([method, value]) => (
            <Text style={[styles.totalLine, { fontSize: 12 }]} key={method}>
              Total {paymentMethodIcons[method]?.label || method.charAt(0).toUpperCase() + method.slice(1)}:{" "}
              {formatCurrency(value)}
            </Text>
          ))} */}
          {/* <Text style={[styles.totalLine, { fontSize: 15 }]}>
            Total Venda c/ desconto: {formatCurrency(totals.sellDisc)}
          </Text> */}
        </View>
      </Page>
    </Document>
  );
};

export default ReportPDF;
